var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H3.5C3.36739 8.5 3.24021 8.44732 3.14645 8.35355C3.05268 8.25979 3 8.13261 3 8C3 7.86739 3.05268 7.74021 3.14645 7.64645C3.24021 7.55268 3.36739 7.5 3.5 7.5Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.70692 7.9999L7.85392 12.1459C7.9478 12.2398 8.00055 12.3671 8.00055 12.4999C8.00055 12.6327 7.9478 12.76 7.85392 12.8539C7.76003 12.9478 7.63269 13.0005 7.49992 13.0005C7.36714 13.0005 7.2398 12.9478 7.14592 12.8539L2.64592 8.3539C2.59935 8.30745 2.56241 8.25228 2.5372 8.19153C2.512 8.13079 2.49902 8.06567 2.49902 7.9999C2.49902 7.93413 2.512 7.86901 2.5372 7.80827C2.56241 7.74752 2.59935 7.69234 2.64592 7.6459L7.14592 3.1459C7.2398 3.05201 7.36714 2.99927 7.49992 2.99927C7.63269 2.99927 7.76003 3.05201 7.85392 3.1459C7.9478 3.23979 8.00055 3.36712 8.00055 3.4999C8.00055 3.63267 7.9478 3.76001 7.85392 3.8539L3.70692 7.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.a845a9d7bf01cbabbafaa8a4f8fce811.svg";
export { ForwardRef as ReactComponent };